import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import states from '../../modules/states';
import { toPercent } from '../../modules/text';
import { getMedianHouseholdIncome, getRatesByState } from './data';

function AveragePrice() {
  const { stateCode } = useParams();

  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [monthlyPrice, setMonthlyPrice] = useState(null);
  const [averageIncomeData, setAverageIncomeData] = useState(null);

  useEffect(() => {
    setReady(false);
    setError(null);

    // function getRatesByState() {
    //   let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]}`;
    //   whereClause += composeWhereClause({});

    //   return rdsTabulate('ccdc', 'county_setting_group_rate_annual', {
    //     dims: 'state',
    //     measure: 'average_rate:AVG(rate)',
    //     where: whereClause,
    //   }, true);
    // }

    // function getMedianHouseholdIncome() {
    //   return rdsSelect('3rdparty', 'acs_sams_state_wide', {
    //     cols: 'inc_hh,inc_fam_married,inc_fam_nospouse',
    //     where: `state_fips=${stateFIPS[stateCode.toUpperCase()]}`,
    //     format: 'amcharts',
    //     inject: false,
    //   }, true);
    // }

    Promise.all([getRatesByState(stateCode), getMedianHouseholdIncome(stateCode)])
      .then((responses) => {
        setMonthlyPrice(responses[0].parsedBody.dataProvider[0].average_rate / 12);
        setAverageIncomeData(responses[1].parsedBody.dataProvider[0]);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <Typography variant="body1">
        In <b>{states[stateCode.toUpperCase()]}</b>, married-couple families pay, on average, <b>{toPercent(monthlyPrice / (averageIncomeData.inc_fam_married / 12))}</b> of their income for child care.
        <br /><br />
        Single-parent families pay, on average, <b>{toPercent(monthlyPrice / (averageIncomeData.inc_fam_nospouse / 12))}</b> of their income for child care.
        <br /><br />
        Affordability varies by setting, child age, race and ethnicity, and nativity.
      </Typography>
    </>
  );
}

export default AveragePrice;
